import { FunctionComponent, ReactElement, useContext, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import {
  BaseCheckbox,
  ButtonLink,
  EmailInput,
  EmailRules,
  HomePhoneRules,
  MobilePhoneRules,
  PhoneInput,
  PhoneInputDS,
} from '../../components/DesignSystem';
import { store } from '../../store/store';
import { updateStore } from '../../store/store.actions';
import { FormText, FormTips } from '../../styles/TypoStyle';

const ContainerOptinOffer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-top: 32px;
`;
const OptinOfferDetail = styled(FormTips)`
  margin-top: 8px;
`;
const OptinOfferMain = styled(FormText)``;

const ButtonContainer = styled.div`
  display: ${(props: { displayOptionalPhone: boolean }) => (props.displayOptionalPhone ? 'none' : 'flex')};

  button-link {
    margin-top: 23.5px;
  }
`;
const ContainerOptionalPhone = styled.div`
  .optional-phone {
    display: ${(props: { displayOptionalPhone: boolean }) => (props.displayOptionalPhone ? 'flex' : 'none')};
  }
`;

const Contact: FunctionComponent<Record<string, never>> = (): ReactElement => {
  const homePhoneRef = useRef<PhoneInputDS & HTMLInputElement>(null);
  // const employmentPhoneRef = useRef<HTMLInputElement>(null);
  const {
    state: { holder },
    geoLoc,
    dispatch,
  } = useContext(store);
  const [displayOptionalPhone, setDisplayOptionalPhone] = useState<boolean>(
    holder?.contact?.homePhone || holder?.contact?.employmentPhone ? true : false,
  );
  const onOptinOfferChange = (e: Event) => {
    dispatch(updateStore({ holder: { contact: { optinOffer: (e as CustomEvent)?.detail?.value } } }));
  };

  // on AddressMail change
  const onAddressMailChange = (e: Event & { currentTarget?: { value?: unknown } | null }) => {
    dispatch(updateStore({ holder: { contact: { addressMail: e.currentTarget?.value } } }));
  };
  // on MobilePhone change
  const onMobilePhoneChange = (e: Event & { currentTarget?: { value?: unknown } | null }) => {
    dispatch(updateStore({ holder: { contact: { mobilePhone: String(e.currentTarget?.value).replace(/\s/g, '') } } }));
  };
  // on HomePhone change
  const onHomePhoneChange = (e: Event & { currentTarget?: { value?: unknown } | null }) => {
    dispatch(updateStore({ holder: { contact: { homePhone: String(e.currentTarget?.value).replace(/\s/g, '') } } }));
  };
  // on HomePhone change
  const onEmploymentPhoneChange = (e: Event & { currentTarget?: { value?: unknown } | null }) => {
    dispatch(updateStore({ holder: { contact: { employmentPhone: e.currentTarget?.value } } }));
  };

  const onClickOptionalPhone = () => {
    setDisplayOptionalPhone(true);
  };
  useEffect(() => {
    const checkOptionalPhoneValidity: (phone: HTMLInputElement) => boolean = (phone) => {
      const value = phone.value;
      if (value.length == 0) return true;
      const regExp = new RegExp('^0[0-9 ]{9}$', 'g');
      return regExp.test(value);
    };
    if (!!homePhoneRef && homePhoneRef.current !== null) {
      (homePhoneRef.current as unknown as PhoneInputDS).customValidityPattern = [
        {
          regexp: () => checkOptionalPhoneValidity(homePhoneRef.current!),
          errorMessage: 'Votre numéro de domicile doit contenir 10 chiffres et commencer par 0.',
        },
      ];
    }
    // if (!!employmentPhoneRef && employmentPhoneRef.current !== null) {
    //   (employmentPhoneRef.current as unknown as PhoneInputDS).customValidityPattern = [
    //     {
    //       regexp: () => checkOptionalPhoneValidity(employmentPhoneRef.current!),
    //       errorMessage: 'Votre numéro de professionnel doit contenir 10 chiffres et commencer par 0.',
    //     },
    //   ];
    // }
  }, [displayOptionalPhone, homePhoneRef.current]);

  return (
    <>
      <EmailInput
        class="to-validate trackable-blur"
        required
        label="Adresse e-mail"
        data-id="addressMail"
        placeholder="exemple@exemple.com"
        maxLength="50"
        value={holder?.contact?.addressMail}
        error-message="Veuillez renseigner votre adresse e-mail."
        onInputChange={onAddressMailChange}
        onLetterChanged={onAddressMailChange}
        replacement={EmailRules.replacement}
        customValidityPattern={EmailRules.customValidityPattern}
      ></EmailInput>
      <PhoneInput
        class="to-validate trackable-blur"
        required
        label="Numéro de mobile"
        data-id="mobilePhone"
        placeholder="06 00 00 00 00"
        maxLength="10"
        value={holder?.contact?.mobilePhone}
        error-message="Veuillez renseigner votre numéro de mobile."
        onInputChange={onMobilePhoneChange}
        onLetterChanged={onMobilePhoneChange}
        replacement={MobilePhoneRules.replacement}
        customValidityPattern={MobilePhoneRules.customValidityPattern}
      ></PhoneInput>
      <ContainerOptionalPhone {...{ displayOptionalPhone }}>
        <PhoneInput
          ref={homePhoneRef}
          class="to-validate trackable-blur optional-phone"
          show-required
          label="Numéro de domicile"
          data-id="homePhone"
          placeholder="01 00 00 00 00"
          maxLength="10"
          value={holder?.contact?.homePhone}
          onInputChange={onHomePhoneChange}
          onLetterChanged={onHomePhoneChange}
          replacement={HomePhoneRules.replacement}
          customValidityPattern={HomePhoneRules.customValidityPattern}
        ></PhoneInput>
        {/* <PhoneInput
          ref={employmentPhoneRef}
          class="to-validate trackable-blur optional-phone"
          show-required
          label="Numéro professionnel"
          data-id="employmentPhone"
          placeholder="01 00 00 00 00"
          maxLength="14"
          value={contact?.employmentPhone}
          onInputChange={onEmploymentPhoneChange}
          onLetterChanged={onEmploymentPhoneChange}
        ></PhoneInput> */}
      </ContainerOptionalPhone>
      <ButtonContainer {...{ displayOptionalPhone }}>
        <ButtonLink icon="circleOutline" onClick={onClickOptionalPhone} label="Ajouter un autre numéro" />
      </ButtonContainer>
      <ContainerOptinOffer>
        <BaseCheckbox onCheckedChanged={onOptinOfferChange} checked={holder?.contact?.optinOffer || null}>
          {geoLoc === 'CTLM' && (
            <OptinOfferMain>
              J’accepte de recevoir les offres commerciales de BNP Paribas Personal Finance par voie électronique{' '}
            </OptinOfferMain>
          )}
          {geoLoc === 'CMAG' && (
            <OptinOfferMain>
              J'accepte de recevoir les offres commerciales de Crédit Moderne Antilles Guyane par voie électronique.
            </OptinOfferMain>
          )}
          {geoLoc === 'CMOI' && (
            <OptinOfferMain>
              J'accepte de recevoir les offres commerciales de Crédit Moderne Océan Indien par voie électronique.
            </OptinOfferMain>
          )}
        </BaseCheckbox>
        {geoLoc === 'CTLM' && (
          <OptinOfferDetail>
            En acceptant, vous pouvez recevoir dès à présent des offres commerciales par voie électronique de BNP
            Paribas Personal Finance et ce même si vous ne validez pas votre demande de financement.
          </OptinOfferDetail>
        )}
        {geoLoc === 'CMAG' && (
          <OptinOfferDetail>
            En cochant cette case, vous pouvez recevoir dès à présent des offres commerciales par voie électronique de
            Crédit Moderne Antilles Guyane et ce même si vous ne validez pas votre demande de financement.
          </OptinOfferDetail>
        )}
        {geoLoc === 'CMOI' && (
          <OptinOfferDetail>
            En cochant cette case, vous pouvez recevoir dès à présent des offres commerciales par voie électronique de
            Crédit Moderne Océan Indien et ce même si vous ne validez pas votre demande de financement.{' '}
          </OptinOfferDetail>
        )}
      </ContainerOptinOffer>
    </>
  );
};

export default Contact;
